var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6ZM1.39691 5.48725C1.11275 5.48725 0.913198 5.25809 0.958589 4.97851C0.958589 4.97851 0.925379 5.14262 0.959388 4.97454C1.43469 2.62554 3.51083 0.857143 6 0.857143C8.84032 0.857143 11.1429 3.15968 11.1429 6C11.1429 8.84032 8.84032 11.1429 6 11.1429C3.5136 11.1429 1.43931 9.37839 0.960979 7.03329C0.926193 6.86275 0.958519 7.02101 0.958519 7.02101C0.916479 6.74039 1.11375 6.5129 1.39692 6.5129H6.43093C6.62048 6.5129 6.66479 6.62153 6.52995 6.75548L5.5948 7.6867C5.10999 8.17029 5.83738 8.89543 6.32219 8.41201L8.41976 6.35042C8.62256 6.15178 8.62221 5.83084 8.41734 5.63195L6.32219 3.58797C5.83738 3.10455 5.10999 3.82986 5.5948 4.31328L6.52995 5.24462C6.66482 5.37862 6.6197 5.48725 6.43093 5.48725H1.39691Z",
    fill: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/PendingIcon.58f7865e303c05f1481531cd4a3e995f.svg";
export { ForwardRef as ReactComponent };